module.exports = __webpack_public_path__ + "static/media/xuanzhong@2x.f879f116.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/xuanzhong@2x.png
// module id = 1872
// module chunks = 0 1